const MEMBER_NODE = 'member';

export default MEMBER_NODE;
